<div class="card">
  <form [formGroup]="phoneForm" class="form">
    <flame-form-field
      [ngClass]="{
        'not-clean': phoneForm.controls['phoneNumber']?.value?.toString()?.length < 12
      }"
      [showCounter]="false" 
      [showClear]="true" 
      appearance="card"
      class="field"
    >
      <label for="phone">{{formTitle}}</label>
      <input
        class="fl-font-quantity-title-l"
        formControlName="phoneNumber"
        name="phone"
        id="phone"
        flameInput
        cellPhoneMask
        type="tel"
        placeholder="00 0000 0000"
        [maxlength]="12"
        #phoneInput
        (input)="onInput(phoneInput.value)"
      />
    </flame-form-field>

    <flame-icon 
      class="card__directory"
      svgIcon="contacts" 
      size="l" 
      (click)="openDirectory()"
      >
    </flame-icon>
  </form>
</div>
